import { render, staticRenderFns } from "./contactusB2BEdit.vue?vue&type=template&id=70543b8b&scoped=true"
import script from "./contactusB2BEdit.vue?vue&type=script&lang=js"
export * from "./contactusB2BEdit.vue?vue&type=script&lang=js"
import style0 from "./contactusB2BEdit.vue?vue&type=style&index=0&id=70543b8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70543b8b",
  null
  
)

export default component.exports